import { SET_LANG } from "../types";

export default (state = {}, action = {}) => {
  if (action.type === SET_LANG) {
    return action.payload;
  }
  return state;
};
